import { useDeferredScript } from './useScript';

export function useGTM(gtmId = 'GTM-NRPJWTR') {
  const status = useDeferredScript(
    `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
  );
  return status;
}
